import {RemotePostCheckoutPayment} from 'data/usecases';
import {PostCheckoutPayment} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {MyPaymentsFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makePostCheckoutPayment = (): PostCheckoutPayment =>
	new RemotePostCheckoutPayment(
		makeBFFApiUrl(MyPaymentsFlowEndPoints.checkoutPayment),
		makeAuthorizeHttpClientDecorator(),
	);
